module.exports = __webpack_public_path__ + "img/btn-save.4af6d63f.png";